import { render, staticRenderFns } from "./TransactionFundraisingRewardPurchase.vue?vue&type=template&id=0fc59f2f&scoped=true&"
import script from "./TransactionFundraisingRewardPurchase.vue?vue&type=script&lang=ts&"
export * from "./TransactionFundraisingRewardPurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc59f2f",
  null
  
)

export default component.exports